import { PromptResponse } from '../../../models/monitor/PromptResponse';
import { client } from '../../apiClient';
import { MonitorPromptResponse } from '../../../models/monitor/MonitorPromptResponse';
import { PromptsData } from '../../../../pages/prompt/models/PromptsData';
import { ChatType } from '../../../types/monitor/ChatType';
import { getDefaultRange } from '../../../utils/utils';
import { format } from 'date-fns';
import { MonitorPrompt } from '../../../models/monitor/MonitorPrompt';

export const PROMPT_ENDPOINT = '/monitor/prompt';

export const getPromptData = async (id: string): Promise<PromptResponse> => {
  return client(true, true)
    .get<MonitorPromptResponse[]>(`${PROMPT_ENDPOINT}/${id}`)
    .then((response) => response.data)
    .catch((error) => error);
};

export const getPromptsList = async (): Promise<PromptsData[]> => {
  return client(true, true)
    .get<PromptsData[]>(`${PROMPT_ENDPOINT}/list`)
    .then((response) => response.data)
    .catch((error) => error);
};

export const getMonitorsForProject = async (projectId: number): Promise<MonitorPrompt[]> => {
  const { data } = await client(true, true).get<MonitorPrompt[]>(
    `/monitor/prompt/list/project/prompts/${projectId}`
  );
  return data;
};

export const removePrompt = async (id: number | undefined): Promise<boolean> => {
  return client(true, true)
    .delete<boolean>(`${PROMPT_ENDPOINT}/remove/${id}`)
    .then((response) => response.data)
    .catch((error) => error);
};

export const pauseMonitor = async (monitorId: number): Promise<boolean> => {
  return client(true, true)
    .post<boolean>(`${PROMPT_ENDPOINT}/pause/${monitorId}`)
    .then((response) => response.data);
};

export const runMonitor = async (monitorId: number): Promise<boolean> => {
  return client(true, true)
    .post<boolean>(`${PROMPT_ENDPOINT}/run/${monitorId}`)
    .then((response) => response.data);
};

export const bulkPauseMonitors = async (monitorIds: number[]): Promise<number> => {
  return client(true, true)
    .post<number>(`${PROMPT_ENDPOINT}/bulk-pause`, { monitorIds })
    .then((response) => response.data);
};

export const bulkRunMonitors = async (monitorIds: number[]): Promise<number> => {
  return client(true, true)
    .post<number>(`${PROMPT_ENDPOINT}/bulk-run`, { monitorIds })
    .then((response) => response.data);
};

export const bulkRemoveMonitors = async (monitorIds: number[]): Promise<number> => {
  return client(true, true)
    .delete<number>(`${PROMPT_ENDPOINT}/bulk-remove`, { data: { monitorIds } })
    .then((response) => response.data);
};

export const exportMonitorSources = async (
  promptId: number,
  chatType: ChatType,
  domain: string,
  from?: Date | null,
  to?: Date | null
): Promise<Blob> => {
  const defaultRange = getDefaultRange();
  from = from ? new Date(from) : defaultRange[0];
  to = to ? new Date(to) : defaultRange[1];

  const formattedFrom = format(from, 'yyyy-MM-dd');
  const formattedTo = format(to, 'yyyy-MM-dd');

  return client(true, true)
    .get<Blob>(
      `${PROMPT_ENDPOINT}/export-monitor-sources/${promptId}/${formattedFrom}/${formattedTo}/${chatType}/${domain}`,
      {
        responseType: 'blob',
      }
    )
    .then((response) => response.data)
    .catch((error) => error);
};
